import { categoryTab } from '@/layout/state/state';
import tokensTabTemplate from './tokensTabTemplate';

export default {
  ...tokensTabTemplate('token-management', ['token-management'], ({ tokens }) => tokens.read, 'token-management'),
  componentState: ({ url }) => categoryTab(url, 'admin'),
  order: 905,
};
